import paymentProcessing from './paymentProcessing'
import accountDetails from './accountDetails'

export default {
  namespaced: true,
  modules: { accountDetails, paymentProcessing },
}
